import { useLingui } from '@lingui/react';
import styled from 'styled-components';
import { WrapperItem } from '~/components/ui/wrapper-item';
import Modal from '~/components/ui/modal';
import Button from '~/components/ui/button';
import { useNavigate, useParams } from 'react-router-dom';
import { SPText } from '~/components/styles/styles';
import { GQL_QUIT_BATTLE } from '~/gql/battles/battles';
import { useMutation } from '@apollo/client';
import { authClient } from '~/helpers/apollo';

interface IProps {
  open: boolean;
  onClose: () => void;
  playerType: 'challenger' | 'challenged';
}
type TProps = IProps;

export default function QuitBattleDialog({
  open,
  onClose,
  playerType,
}: TProps) {
  const { i18n } = useLingui();
  const navigate = useNavigate();
  const { id } = useParams();

  const [quitBattle] = useMutation(GQL_QUIT_BATTLE, {
    client: authClient,
    variables: { battlePlayerTrackingId: id ?? '' },
  });

  return (
    <Modal
      heightPortrait="90%"
      heightLandscape="70%"
      widthPortrait="95%"
      widthLandscape="60%"
      onClose={onClose}
      open={open}
    >
      <Container>
        <WrapperItem setMaxHeight widthPortrait="100%" widthLandscape="100%">
          <ContentWrapper>
            <SPText $textAlign="center">
              {playerType === 'challenged'
                ? i18n._('common.quit.battle.text.challenged')
                : i18n._('common.quit.battle.text.challenger')}
            </SPText>

            <SDivBtn className={open ? 'open' : 'closed'}>
              {open && (
                <>
                  <Button
                    type={'button'}
                    color="primary"
                    disabled={!open}
                    onClick={() => {
                      quitBattle();
                      navigate('/home');
                    }}
                    margin="20px 0 0 0"
                    width="auto"
                  >
                    {i18n._('common.quit.battle')}
                  </Button>
                  <Button
                    type={'button'}
                    color="secondary"
                    disabled={!open}
                    onClick={onClose}
                    margin="20px 0 0 0"
                    width="auto"
                  >
                    {i18n._('common.game.continue.batle')}
                  </Button>
                </>
              )}
            </SDivBtn>
          </ContentWrapper>
        </WrapperItem>
      </Container>
    </Modal>
  );
}

const ContentWrapper = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

const SDivBtn = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: auto;
  & > button:last-of-type {
    margin-left: 20px;
  }
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 5px;
  width: 100%;
`;
